import CompanyLogoName from './CompanyLogoName';

export default CompanyLogoName;
